import { useState } from "react";

export function SlideTemplateWithCounter({
  src = "/assets/images/slide-templete-2.svg",
  alt: _alt,
  onClick,
  isSelected = false,
}: {
  src?: string;
  alt?: string;
  onClick?: () => void;
  isSelected?: boolean;
}) {
  // Determine counter behavior based on template
  const isGrid = src?.includes("templete-1");
  const min = 10;
  const max = isGrid ? 16 : 20;
  const step = isGrid ? 2 : 1;
  const [count, setCount] = useState(12);

  return (
    <div
      className={`slide-template${isSelected ? " selected" : ""}`}
      style={{
        background: `url(${src}) center center / cover no-repeat`,
        position: "relative",
      }}
      onClick={onClick}
    >
      {/* Counter display */}
      <div className="counter-display">{count}</div>
      <div className="counter-controller">
        <button
          className="counter-button"
          onClick={(e) => {
            e.stopPropagation();
            setCount((c) => Math.max(min, c - step));
          }}
          aria-label="Decrease"
        >
          <i className="f-icon minus-icon"></i>
        </button>
        <button
          className="counter-button"
          onClick={(e) => {
            e.stopPropagation();
            setCount((c) => Math.min(max, c + step));
          }}
          aria-label="Increase"
        >
          <i className="f-icon plus-icon"></i>
        </button>
      </div>
    </div>
  );
}
